.pricewrapper {
  display: var(--haus-Price-pricewrapper__display, flex);
  flex-direction: var(--haus-Price-pricewrapper__flex-direction, row);
  justify-content: var(--haus-Price-pricewrapper__justify-content, center);
  align-items: var(--haus-Price-pricewrapper__align-items, center);
  gap: var(--haus-Price-pricewrapper__gap, 8px);
}
